import { useContext } from "react";
import { AppStateContext } from "../utils/AppStateContext";

export function useCredentials() {
    const appContext = useContext(AppStateContext);
    return appContext.credentials;
}

export default useCredentials;